import React from 'react';
import CustomerError from '../../../components/CustomerError';
import {UserType} from '../../../hooks/apis/useUser';
import ContestEditForm, {IContestEditForm} from '../../../components/Contest/EditForm';
import UseContest, {ContestStatus, ContestType, IContest} from '../../../hooks/apis/useContest';
import {Button, Card, Space, Table, Tag} from 'antd';
import Text from 'antd/lib/typography/Text';
import QuickRouter from '../../../utils/QuickRouter';
import UseContestNotice, {IContestNotice} from '../../../hooks/apis/useContestNotice';
import moment from 'moment';
import useAuth from '../../../utils/AuthContext';
import {useMount} from 'react-use';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import useQuickRouter from '../../../utils/QuickRouter';
import {useParams} from 'react-router-dom';

export default function ManageContestNoticeListPage() {
  const auth = useAuth();
  const listState = UseContestNotice.list();
  const queryById = UseContest.queryById();
  const params = useParams() as {contestId?: string};
  const contestId = parseInt(params?.contestId || '');
  const quickRouter = useQuickRouter();

  function refresh() {
    queryById
      .request({
        id: contestId,
      })
      .then(() => {
        listState
          .request({includeHide: true, contestId})
          .then()
          .catch(CommonApiErrorHandler);
      })
      .catch(CommonApiErrorHandler);
  }

  useMount(() => {
    refresh();
  });

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      <Card
        title={'通知列表: ' + queryById.data?.name}
        extra={
          <Space>
            <Button onClick={refresh}>刷新</Button>
            <Button onClick={() => quickRouter.manageContestNoticeNew(contestId)}>新建</Button>
          </Space>
        }>
        <Table<IContestNotice> loading={listState.loading} rowKey={'id'} dataSource={listState.data} bordered>
          <Table.Column<IContestNotice> title={'ID'} dataIndex={'id'} width={100} />
          <Table.Column<IContestNotice> title={'通知标题'} render={(_, item) => <Text strong>{item.title}</Text>} />
          <Table.Column<IContestNotice> title={'发布时间'} width={180} render={(_, item) => moment(item.publishedDate).format('YYYY-MM-DD')} />
          <Table.Column<IContestNotice>
            title={'是否隐藏'}
            align={'center'}
            width={100}
            render={(_, item) => <Tag color={item.isHide ? 'danger' : 'success'}>{item.isHide ? '隐藏' : '公开'}</Tag>}
          />
          <Table.Column<IContest>
            title={'操作'}
            align={'center'}
            width={150}
            render={(_, item) => (
              <Space>
                <a onClick={() => quickRouter.manageContestNoticeEdit(contestId, item.id)}>编辑</a>
              </Space>
            )}
          />
        </Table>
      </Card>
    </div>
  );
}
